import { createApiAction, createAction } from '@saucelabs/sl-util-redux';

import * as api from './api';
import * as types from './types';

export const getDeviceList = createApiAction(
  types.DEVICE_LIST_GET,
  (payload) => api.fetchPrivateDevices(payload),
);

export const cleanup = createAction(types.CLEANUP);
